import React from "react";

export default function About() {
  return (
    <div className="pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            About Us
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our mission, vision, and the innovative approach that
            drives our research and consulting work.
          </p>
        </div>
        <div className="mb-20">
          <div className="relative w-full h-96 rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="/about.webp"
              alt="About TRL"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    backgroundImage: "linear-gradient(180deg,#93C754,#7FB740)",
                  }}
                ></span>
                Our Mission
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  Theophrastus Research Lab harnesses the Aegean’s unique
                  position as a testing ground for advancing climate resilience,
                  security, and understanding the impacts of people on the move.
                </p>
                <p>
                  Situated at the crossroads of Europe, Asia, and Africa, we
                  operate at the intersection of environmental science, social
                  research, and policy design, delivering rigorous analysis and
                  actionable strategies to governments, institutions, and
                  communities.
                </p>
                <p>
                  With expertise in environmental research, crisis management,
                  and security studies, TRL provides evidence-based solutions
                  that strengthen resilience and support sustainable
                  development.
                </p>
              </div>
            </div>
          </div>
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-gray-300 to-gray-600 rounded mr-4"></span>
                Our Story
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  Founded in 2025 in Mytilene, Lesvos, the Theophrastus Research
                  Lab was created by a multidisciplinary group of scientists,
                  practitioners, and professionals with backgrounds in
                  environmental sciences, humanitarian response, security, and
                  migration studies.
                </p>
                <p>
                  While the non‑profit{" "}
                  <a
                    href="https://theori.eu/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#7FB740] hover:text-[#6ea436] underline"
                  >
                    Theophrastus Research Institute
                  </a>{" "}
                  focuses on academic research and civic engagement, the
                  Research Lab was established as its applied and
                  consultancy‑oriented counterpart. TRL concentrates on
                  transforming research outcomes into practical solutions for
                  institutions, states, and organizations facing urgent
                  environmental and security challenges.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="relative p-12 rounded-3xl shadow-xl border border-gray-100"
          style={{
            background: "linear-gradient(135deg,#f6fbf0,#eef7e5,#f6fbf0)",
          }}
        >
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Dual Identity
            </h2>
            <p className="text-xl text-gray-600">
              Bridging the gap between research and real‑world application
            </p>
            <p className="text-gray-600 max-w-3xl mx-auto mt-4">
              This dual structure enables TRL to operate both as a research
              partner and as a technical advisor in contexts that demand quick,
              credible, and solution‑oriented responses.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="text-center">
                <div className="-mx-8 -mt-8 mb-6 overflow-hidden rounded-t-2xl">
                  <div className="w-full aspect-[16/9]">
                    <img
                      src="/dual/Scientific Excellence.webp"
                      alt="Scientific Excellence"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Scientific Excellence
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Conducting applied research, experimental development, and
                  policy-relevant analysis with rigorous scientific methodology.
                </p>
              </div>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="text-center">
                <div className="-mx-8 -mt-8 mb-6 overflow-hidden rounded-t-2xl">
                  <div className="w-full aspect-[16/9]">
                    <img
                      src="/dual/Practical Solutions.webp"
                      alt="Practical Solutions"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Practical Solutions
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Supporting decision-makers through consulting,
                  capacity-building, and tailored strategies that create real
                  impact.
                </p>
              </div>
            </div>
          </div>
          <div className="text-center mt-12">
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              This unique structure ensures that TRL can operate both as a
              research partner and as a technical advisor in contexts that
              demand quick, credible, and solution-oriented responses.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
